const missingAttrValidator = (attrName, value) => !value &&
    `${attrName} cannot be empty, please make sure to set this attribute`;

export { missingAttrValidator };
//# sourceMappingURL=commonValidators.js.map
